import { itemDocSerializer } from "@megaron/catalog-contracts";
import { HttpAction } from "@megaron/http-service";
import { itemsSortFields } from "@megaron/megarax-uri";
import { Serializers } from "@megaron/serializers";

export { itemsSortFields };
export type { ItemSortField } from "@megaron/megarax-uri";

export const itemActions = {
  searchItems: HttpAction({
    path: "/items",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      sort: Serializers.sortFilter(itemsSortFields).asJsonString(),
      groups: Serializers.jsonString(Serializers.array(Serializers.string)),
      priceLists: Serializers.jsonString(Serializers.array(Serializers.string)),
      isArchived: Serializers.jsonString(Serializers.boolean),
      isInAvailability: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.paginatedList(itemDocSerializer),
    requiresAuth: true,
  }),

  searchProductGroups: HttpAction({
    path: "/items/productsGroups",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),

  searchProductIds: HttpAction({
    path: "/items/productsIds",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      isArchived: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),
};
